<template>
  <div>
    <div class="headbt">
      个人中心
    </div>
    <div class="uinfo">
    	<div class="uinfo_1">
    	<ul class="list-group">
    	 <li class="list-group-item  userliebiao">
    	 	<div class=" col-sm-4 col-4 col-md-4" >
         <!-- <span class="zct"> <img src="../../assets/img/xm.png"></span> -->
    			姓名
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo" >
    			{{userinfos.nickName}}
    			<!-- <span class="yjt"><img src="../../assets/img/yjt.png" ></span> -->
    		</div>
    	 </li>
       <li class="list-group-item  userliebiao">
       	<div class=" col-sm-4 col-4 col-md-4" >
         <!-- <span class="zct"> <img src="../../assets/img/xm.png"></span> -->
           			性别
           		</div>
           		<div class=" col-sm-8 col-8 col-md-8 userinfo"  v-if="userinfos.sex == 1" >
           			男
           		</div>
              <div class=" col-sm-8 col-8 col-md-8 userinfo"  v-else >
              	女
              </div>
       </li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
          <!-- <span class="zct"> <img src="../../assets/img/sjh.png"></span> -->
    			手机号
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"   >
    		{{userinfos.phonenumber}}
    		<!-- <span class="yjt"><img src="../../assets/img/yjt.png" ></span> -->
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			密码
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  @click="tz('/user/upassedit')">
            <span class="yjt"><img src="../../assets/img/yjt.png" ></span>
    		</div>
    	</li>
      <li class="list-group-item  userliebiao">
      	<div class=" col-sm-4 col-4 col-md-4" >
            <!-- <span class="yjt"><img src="../../assets/img/xx.png" ></span> -->
      		出生日期
      	</div>
      	<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
      		{{userinfos.birthDate}}
      	</div>
      </li>
      <li class="list-group-item  userliebiao">
      	<div class=" col-sm-4 col-4 col-md-4" >
            <!-- <span class="yjt"><img src="../../assets/img/xx.png" ></span> -->
      		学校
      	</div>
      	<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
      		{{userinfos.deptName}}
      	</div>
      </li>


      <li class="list-group-item  userliebiao">
      	<div class=" col-sm-4 col-4 col-md-4" >
      		班级
      	</div>
      	<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
      	{{userinfos.classesName}}
      	</div>
      </li>
      <li class="list-group-item  userliebiao">
      	<div class=" col-sm-4 col-4 col-md-4" >
           <!-- <span class="yjt"><img src="../../assets/img/xh.png" ></span> -->
      		学籍号
      	</div>
      	<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
      			{{userinfos.schoolNum}}
      	</div>
      </li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
           <!-- <span class="yjt"><img src="../../assets/img/xh.png" ></span> -->
    			学号
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    				{{userinfos.userName}}
    		</div>
    	</li>

    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			学生状态
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo" v-if="userinfos.finishStatus == 1"  >
    			未毕业
    		</div>
        <div class=" col-sm-8 col-8 col-md-8 userinfo" v-if="userinfos.finishStatus == 2"  >
        	已毕业
        </div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			入学年份
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			{{userinfos.inYear}}
    		</div>
    	</li>

      <li class="list-group-item  userliebiao">
      	<div class=" col-sm-4 col-4 col-md-4" >
      		身份证号
      	</div>
      	<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
      		{{userinfos.idCard}}
      	</div>
      </li>
    	<!-- <li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			就读方式
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			全日制
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			证件类型
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			18666666666
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			机号
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			中华人民共和国居民身份证
    		</div>
    	</li> -->

    	<!-- <li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			政治面貌
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			群众
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			健康状态
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			健康
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			国籍
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			中国
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			民族
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			汉族
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			籍贯
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			甘肃
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			家庭住址
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			陕西省西安市雁塔区丈八1路33号
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			户口性质
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			城镇
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			户口所在地
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			西安
    		</div>
    	</li>
    	<li class="list-group-item  userliebiao">
    		<div class=" col-sm-4 col-4 col-md-4" >
    			创建日期
    		</div>
    		<div class=" col-sm-8 col-8 col-md-8 userinfo"  >
    			2024-01-01 12:00:00
    		</div>
    	</li>

    	</ul> -->

      <li class="list-group-item  userliebiao" style="border-bottom: none !important;">
      	<div class=" col-sm-4 col-4 col-md-4" >

      	</div>
      	<div class=" col-sm-8 col-8 col-md-8 userinfo"  style="color: red;" @click="tc">
           <span class="yjt"><img src="../../assets/img/tcdl.png" ></span>
      		退出登录
      	</div>
      </li>

      </ul>
    	</div>
    </div>

    <div class="bkx">

    </div>

		<div class="footer ">
		  <div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/base/index')">
			  <div class="dibumenu">
          	 <img src="../../assets/img/home.png" >
			</div>
			  <div class="xmtitle ">
			  	首页
			  </div>
		  </div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/user/cprw')">
				<div class="dibumenu">
          	<!-- <img src="../../static/wd.png" > -->
             <img src="../../assets/img/cp.png" >
				</div>
				<div class="xmtitle ">
					测评任务
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3"  @click="tz('/user/wdcp')">
				<div class="dibumenu">
				 	 <img src="../../assets/img/wdcp.png" >
				</div>
				<div class="xmtitle ">
					我的测评
				</div>
			</div>
			<div class="item_list_menu col-sm-3 col-3 col-md-3">
				<div class="dibumenu">
					 <img src="../../assets/img/wd_xz.png" >
				</div>
				<div class="xmtitle xmtitle_active">
					我的
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import {getuserinfo,loginout } from '../../api/baseset'
  export default {
      data() {
        return {
          userinfos:{}
        }
      },
      mounted() {
        this.getdata();
     // this.getsjtjs();
      },
      methods: {

        getdata(){

         this.loading = true

           const data = JSON.parse(localStorage.getItem('userdata'))

          if(localStorage.getItem('user_infos')){
              const userinfos = JSON.parse(localStorage.getItem('user_infos'))
              console.log('读取缓存数据')
               this.userinfos = userinfos

          }else{
            let datas = {userId:data.userId}
            getuserinfo(datas)
             .then(res => {

              this.loading = false
               if (res.code != 200) {
                 this.$message({
                   type: 'info',
                   message: res.msg
                 })
               } else {
               // console.log(res)
                this.userinfos = res.data
                localStorage.setItem('user_infos', JSON.stringify( this.userinfos))

               }
             })
             .catch(err => {
               this.loading = false
               this.$message.error('数据加载失败，请稍后再试！')
             })
             }

        },

        // 搜索事件
        search() {
          this.formInline.page = 1
          this.formInline.limit = 10
          this.getdata(this.formInline)
        },
        // 重置搜索
        formReset() {
          this.formInline.key = '';
        },
        shouli() {

        },
        chuli() {
          this.dialogVisible = true;
        },
        tz(url){

          this.$router.push(url);
        },
        tc(){
            loginout()
              .then(res => {

                if (res.code == 200) {
                  //如果请求成功就让他2秒跳转路由
                  setTimeout(() => {
                    this.$store.commit('logout', 'false')
                    this.$router.push({ path: '/login' })
                    this.$message({
                      type: 'success',
                      message: '已退出登录!'
                    })
                  }, 1000)
                } else {
                  this.$message.error(res.msg)
                  this.logining = false
                  return false
                }
              })
              .catch(err => {
                this.logining = false
                this.$message.error('退出失败，请稍后再试！')
              })
        }
      }
    }
  </script>

<style scoped>
  	body{
  			background-color: #EFEFF4;
  		}

  		.footer {
  		  position: fixed ;
  		  bottom: 0;
  		  width: 100%;
  		  height: 60px; /* 底部栏的高度 */

  		  background-color: white;
  		  display: flex;
  		  border-top: solid 1px #E6EAEC;
       /* border: solid 1px red; */
        margin-left:  0 !important;
  		}
  		.item_list_menu{
  			/* border: solid 1px red; */
  			text-align: center;
  		}
  		.dibumenu{
  			width: 100%;
  			text-align: center;
  			padding-top: 3px;
  		}
  		.dibumenu img{
  			width: 24px;
  			height: 24px;
  		}
  		.xmtitle{
  			text-align: center;
  			font-size: 12px;
  			color: #666666;
  		}
  		.xmtitle_active{
  			color: #00DDA3;
  		}


    .list-group{
    	--bs-list-group-border-radius:0 0 0 0 !important;
    }

    .list-group-item{
    	border-radius: 0 0 0 0 ;
    	border: none !important;
    	padding:  0 0 0 0 !important;

    	height: 3rem;
    	line-height:3rem;
    	font-size: 14px;
    	color: #666666;
    	border-bottom: solid  1px #E6EAEC !important;
    }
    .list-group-item:first-child{
    	border-top-left-radius: 0;
    	border-top-right-radius: 0;

    }
    .item_list_menu{
    	/* border: solid 1px red; */
    	text-align: center;
    }
    .userliebiao{
    	display: flex;
    	font-size: 14px;
    	height: auto;
    	padding-top: 5px;
    	padding-bottom: 5px;
    	background-color: white;
    }
    .userinfo{
    	text-align: right;
    }
    .dibuxian{
    	width: 100%;
    	height: 90px;
    }
    .yjt img{
    	width: 24px;
    	height: 24px;
    }

    .bfwrxx_left{
    	text-align: left !important;
    	font-size: 18px  !important;
    	line-height: 40px !important;
    	padding-left: 2% !important;
    }
    .qrbc{
    	width:40%;
    	height: 30px;
    	margin: 0 auto;
    	text-align: center;
    	line-height: 30px;
    	color: white;
    	border-radius: 5px 5px 5px 5px;
    	background-color: #00DDA3;
    	margin-top: 15px;
    	margin-bottom: 10px;
    }
    .uinfo{
    	width: 100%;
    	height: auto;
    	padding-top: 5px;
    	/* padding-bottom: 5px; */
    	background-color: white;
    }
    .uinfo_1{
    	width: 88%;
    	height: auto;
    	margin: 0 auto;
    }
    .bkx{
      width: 100%;
      height: 80px;
    }
    .zct img{
      width: 32px;
      height: 32px;
      margin-top: -25px;
    }
</style>



// WEBPACK FOOTER //
// src/views/user/index.vue